import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check if it's a network error
        if (error.status === 0) {
          // Redirect to maintenance page for network-related issues
          this.router.navigate(['/pages/maintenance']);
        } else {
          // Handle other HTTP errors here if needed
          // For example, you could log these errors or show a notification
        }
        
        return throwError(error);
      })
    );
  }
}
